/** Client device transfer action, rendered inside the call toolbar. */
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { initiateHandoff, requestCompanionHandoff } from '../actions';
import { getUserRole } from '../../base/user-role/functions';
import { IconDeviceTransfer } from '../../base/icons/svg';
import ToolboxItem from '../../base/toolbox/components/ToolboxItem';
import { hasPersistentAuthToken } from '../../vrs-auth/storage';
const HandoffBanner = () => {
    const dispatch = useDispatch();
    const { i18n, ready } = useTranslation();
    const companionDevices = useSelector((state) => state['features/device-handoff']?.companionDevices || []);
    const roomRole = useSelector((state) => state['features/base/jwt']?.user?.role);
    const handoffInProgress = useSelector((state) => state['features/device-handoff']?.handoffInProgress || false);
    const handleTransfer = useCallback((device) => {
        if (device) {
            dispatch(initiateHandoff(device));
        }
        else {
            dispatch(requestCompanionHandoff());
        }
    }, [dispatch]);
    if (!hasPersistentAuthToken() || getUserRole() !== 'client'
        || roomRole === 'guest' || roomRole === 'observer' || handoffInProgress) {
        return null;
    }
    const primaryDevice = companionDevices[0];
    return (React.createElement(ToolboxItem, { accessibilityLabel: `Move this call to ${primaryDevice?.name || 'your other device'}`, icon: IconDeviceTransfer, label: 'Move', labelProps: {}, i18n: i18n, tReady: ready, onClick: () => handleTransfer(primaryDevice), tooltip: 'Move to another device' }));
};
export default HandoffBanner;
